// This file contains utility functions for handling language codes in the current page URL.
// It is hardcoded to support "en-US" and "ja" language codes.

/**
 * Determine the language of the current page.
 * @returns {string} The current language code (e.g., "en-US" or "ja").
 */
export const getCurrentLanguageCode = (activePath = window.location.pathname) => {
  // Check if the URL contains the JA language code
  const isJa = activePath.match(/^(?:\/documentation)?\/ja/)

  // If a match is found, return the language code
  if (isJa) {
    return "ja"
  }

  // If no match is found, return the default language code
  return "en-US"
}

/**
 * Switch the current page to the specified language by updating the URL.
 *
 * The page may not be available in the specified language, which may result in a 404 error.
 * @param {string} newLanguageCode The new language code to switch to (e.g., "en-US" or "ja").
 */
export const switchToLanguage = (newLanguageCode) => {
  const currentLanguageCode = getCurrentLanguageCode()
  if (!newLanguageCode || newLanguageCode === currentLanguageCode) {
    return
  }

  // Replace the language code in the URL with the selected language code
  if (newLanguageCode === "en-US") {
    // Remove the language code from the URL
    window.location.href = window.location.pathname.startsWith("/documentation")
      ? window.location.pathname.replace(/^\/documentation\/(?:ja)?\/?/, "/documentation/")
      : window.location.pathname.replace(/^\/(?:ja)?\/?/, "/")
  } else {
    // Add the language code to the URL if it's not already there
    // or replace the existing language code with the selected language code
    window.location.href = window.location.pathname.startsWith("/documentation")
      ? window.location.pathname.replace(/^\/documentation\/(?:ja)?\/?/, `/documentation/${newLanguageCode}/`)
      : window.location.pathname.replace(/^\/(?:ja)?\/?/, `/${newLanguageCode}/`)
  }
}
